import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import logo from '../../../assets/images/logo.png';
import useUser from '../../../hooks/useUser';

export default function CenterLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { centerLoginMutation, isCenterLoading } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      return toast.error('Please fill all fields');
    }
    try {
      const response = await centerLoginMutation({ email, password });
      if (response?.token) {
        toast.success('Login successful');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.error || 'Something went wrong');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        backgroundColor: '#f9f9f9',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: 400,
          borderRadius: 4,
          textAlign: 'center',
        }}
      >
        <img src={logo} alt="Logo" style={{ width: '120px' }} />

        <Typography fontWeight="bold" sx={{ color: 'rgb(59 55 65)', mb: 1, fontSize: '26px' }}>
          Center Login
        </Typography>

        <Typography variant="h6" sx={{ mb: 3, color: 'gray' }}>
          Enter your email and password below
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            sx={{
              mb: 2,
              '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 12 },
            }}
          />

          <TextField
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            sx={{
              mb: 3,
              '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 12 },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={isCenterLoading}
            sx={{
              backgroundColor: 'rgb(59 55 65)',
              p: 1,
              fontSize: '12px',
              fontWeight: 'bold',
              borderRadius: '10px',
              '&:hover': { backgroundColor: 'rgb(80, 75, 90)' },
            }}
          >
            {isCenterLoading ? 'Logging in...' : 'Login'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
